import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery,
  Autocomplete,
  TextField,
  IconButton,
  Grid,
  CardContent,
  Collapse,
  Divider,
  Stack,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import {
  useDeleteBasicsPolicyMutation,
  useGetAllPolicyGroupByQuery,
  useGetCustomerQuery,
  useGetProductBrandQuery,
  useGetMeetingQuery,
  useGetCustomerWithRelationQuery,
  useGetTeamQuery,
  useDeleteMeetingMutation,
  useDoneMeetingMutation,
  useGetAllHolydaysArrayQuery,
  useCreateMeetingMutation,
  useGetUserQuery,
  useGetMeetingCategoryQuery,
  useGetAllMeetingSubjectQuery,
  useGetAllHolydaysTitleQuery,
  useConnectionRelationShipQuery,
  useGetCustomerRelationQuery,
  useCreateClintEmailRecordMutation,
  useGetEmailRecordQuery,
  useGetClientTypeQuery,
  useGetAllPolicyGroupByHistoryQuery,
  useGetUserInfoOnyQuery,
  useCreateClintSmsRecordMutation,
  useGetSmsRecordQuery,
  useResentSmsClientMutation,
  useResentEmailClientMutation,
  useGetCustomerPolicyReportQuery,
} from "../../Api/attoDeskApi";
import {
  ICustomer,
  IMeeting,
  IPolicy,
  IProductBrand,
  ITeam,
  ICustomerRelative,
  IUserInfo,
  IMeetingCategory2,
  ICustomerRelative2,
  IEmailRecords,
  IClientType,
  IPolicyHistoryRecords,
  IUserAdmin,
  ISmsRecords,
  ICustomerReportList,
} from "../../Api/Interface/api.interface";
import { useNotifier } from "../../Core/Notifier";
import HistoryIcon from "@mui/icons-material/History";
import PolicyOutlinedIcon from "@mui/icons-material/PolicyOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import EventIcon from "@mui/icons-material/Event";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../Components/Delete/DeletePopup";
import {
  formatPhoneNumberForDisplay,
  formatPhoneNumberForDisplaySpace,
} from "../../Components/Validation/validationUtils";
import {
  ClientSource,
  ClientStatus,
  ClientType,
  Gender,
  MaritalStatus,
  widthofReactQuill,
} from "../../Core/Enum/enum";
import NewPopUpCustomer from "../Customer/Edit/index";
import NewPopUpRelative from "../Customer/Edit/relative";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import AlertPopUp from "../../Components/AlertPopUp/AlertPopup";
import RescheduleMeeting from "../Meeting/Edit/rescheduleMeeting";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AvatarImg from "../../Images/avatar.png";
import { toProperCase } from "../../Components/Validation/toProperCase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import dayGridPlugin from "@fullcalendar/daygrid";
import FullCalendar from "@fullcalendar/react";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import { useFormik } from "formik";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs, { Dayjs } from "dayjs";
import TimeDropdown from "../../Components/CustomTimePicker/TimeDropdown";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { styled } from "@mui/material/styles";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import ResentPopup from "../../Components/Delete/ResentEmail";
import ClientListPouup from "../Task/List/clientList";
import AddTaskIcon from "@mui/icons-material/AddTask";

function getGenderLabel(genderId: string) {
  switch (genderId) {
    case Gender.Male:
      return "Male";
    case Gender.Female:
      return "Female";
    case Gender.Other:
      return "Other";
    default:
      return "";
  }
}

function getInsuranceClient(customerClientId: string) {
  switch (customerClientId) {
    case ClientType.InsuranceClient:
      return "Insurance Client";
    case ClientType.RealstatesClient:
      return "Real estate Client";
    default:
      return "";
  }
}

function getMaritalStatusLabel(maritalStatusId: string) {
  switch (maritalStatusId) {
    case MaritalStatus.Single:
      return "Single";
    case MaritalStatus.Married:
      return "Married";
    case MaritalStatus.Divorced:
      return "Divorced";
    case MaritalStatus.Widowed:
      return "Widowed";
    default:
      return "";
  }
}

function getClientStatus(customerClientStatusId: string) {
  switch (customerClientStatusId) {
    case ClientStatus.Active:
      return "Active";
    case ClientStatus.Inactive:
      return "Inactive";
    case ClientStatus.Pending:
      return "Pending";
    case ClientStatus.Closed:
      return "Closed";
    default:
      return "";
  }
}

function getClientSource(customerClientSource: string) {
  switch (customerClientSource) {
    case ClientSource.Referral:
      return "Referral";
    case ClientSource.Website:
      return "Website";
    case ClientSource.WalkIn:
      return "WalkIn";
    case ClientSource.CallCenter:
      return "CallCenter";
    case ClientSource.Email:
      return "Email";
    case ClientSource.SocialMedia:
      return "SocialMedia";
    default:
      return "";
  }
}

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    case "ReceiptUpdated":
      return "Receipt Updated";
    default:
      return "";
  }
};

enum Section {
  Policy = "Policy",
  Info = "Info",
  Email = "Email",
  Note = "Note",
  History = "History",
  Todo = "Todo",
  Meeting = "Meeting",
  Sms = "Sms",
  Task = "Task",
}

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatusGreen: <GrStatusGood color="green" />,
  ChangedStatusOrange: <GrStatusGood color="orange" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const isEmpty = (value: any) =>
  value === null || value === undefined || value === "" || value === "-";

const getStatusType = (oldValue: any, newValue: any) => {
  // console.log("🔍 Checking status:", {
  //   oldValue,
  //   newValue,
  //   oldEmpty: isEmpty(oldValue),
  //   newEmpty: isEmpty(newValue),
  // });

  const oldEmpty = isEmpty(oldValue);
  const newEmpty = isEmpty(newValue);

  if (oldEmpty && !newEmpty) {
    return "Created"; // only new value exists
  } else if (!oldEmpty && !newEmpty) {
    return "Modified"; // both values exist
  } else if (!oldEmpty && newEmpty) {
    return "Deleted"; // only old value exists
  }
  return null; // both empty (no change)
};

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

interface CustomerOption {
  label: string;
  value: number;
}

const variantPropName = (unit: string) => {
  switch (unit) {
    case "policyDrawDay":
      return "Draw Day";
    case "policyPremiumFrequencyDate":
      return "Premium Frequency Date";
    case "policyPremiumFrequency":
      return "Premium Frequency";
    case "policyPremium":
      return "Premium";
    case "policyIssueDate":
      return "Issue Date";
    case "policyPayor":
      return "Payor";
    case "contengentPolicyOwnerId":
      return "Contengent Policy Owner";
    case "jointPolicyOwnerId":
      return "Joint Policy Owner";
    case "policyInsuranceCompanyId":
      return "Insurance Company";
    case "policyNumber":
      return "Policy No";
    case "policyOrderNumber":
      return "Order Number";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [activeSection, setActiveSection] = useState<Section>(Section.Policy);
  const handleContainerChange = (section: Section) => {
    setActiveSection(section);
  };
  const navigate = useNavigate();
  const [currentSearchQueryProject, setCurrentSearchQueryProject] =
    useState("");

  //   const { customerId, policyId } = useParams<{
  //     customerId: string;
  //     policyId: string;
  //   }>();

  const { customerId: customerId } = useParams<{ customerId: string }>();

  const [openAddProject, setOpenAddProject] = useState(false);

  const { showErrorMessage, showMessage } = useNotifier();

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<IPolicy | null>(null);

  const [selectedCoursing, setSelectedCoursing] = useState<ICustomer | null>(
    null
  );

  const [selectedMeeting, setSelectedMeeting] = useState<IMeeting | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogMeeting, setOpenDialogMeeting] = useState(false);
  const [openDialogMeetingEdit, setOpenDialogMeetingEdit] = useState(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [isPaperVisible, setIsPaperVisible] = useState(false);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IMeeting | null>(
    null
  );

  const [openDeleteCategory2, setOpenDeleteCategory2] = useState(false);
  const [coursingToDelete2, setCoursingToDelete2] =
    useState<ISmsRecords | null>(null);

  const [openDeleteCategory23, setOpenDeleteCategory23] = useState(false);
  const [coursingToDelete23, setCoursingToDelete23] =
    useState<IEmailRecords | null>(null);

  const [openDoneMeeting, setOpenDoneMeeting] = useState(false);
  const [meetingToDone, setMeetingToDone] = useState<IMeeting | null>(null);
  const [selectedMeetingRe, setSelectedMeetingRe] = useState<IMeeting | null>(
    null
  );
  const [openDialogMeetingRe, setOpenDialogMeetingRe] = useState(false);
  useEffect(() => {}, [customerId]);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedMeetingData, setSelectedMeetingData] =
    useState<IMeeting | null>(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [expandedTemplateId, setExpandedTemplateId] = useState<string | null>(
    null
  );
  const [expandedTemplateIdHis, setExpandedTemplateIdHis] = useState<
    number | null
  >(null);
  const [newDepartment, { isLoading: meetingSaveIsLoading }] =
    useCreateMeetingMutation();
  const { data: userData } = useGetUserQuery();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const {
    data,
    isLoading,
    isError,
    refetch: getCustomerRefetch,
  } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),
  });

  const { data: allclientData, isLoading: allcilentIsLoading } =
    useGetCustomerQuery({
      searchText: "",
      id: "",
    });

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
    isError: cutomerProjectIsError,
  } = useGetAllPolicyGroupByQuery({
    searchText: currentSearchQueryProject,
    id: "",
    policyCustomerId: String(customerId),
  });

  const {
    data: customerProjectHistoryData,
    isLoading: customerProjectDataHistoryIsLoading,
    refetch: cutomerProjectHistoryRefetch,
    isError: cutomerProjectHistoryIsError,
  } = useGetAllPolicyGroupByHistoryQuery({
    searchText: "",
    id: "",
    policyCustomerId: String(customerId),
  });

  const {
    data: brandListData,
    isLoading: brandIsLoading,
    refetch: refetchBrand,
  } = useGetProductBrandQuery({
    searchText: "",
    isActive: true,
  });

  const {
    data: relationData,
    isLoading: relationIsLoading,
    refetch: refetchRelations,
    isError: relationIsError,
  } = useGetCustomerWithRelationQuery({
    policyCustomerId: String(customerId),
  });

  const {
    data: customerDate,
    isLoading: customerIsLoading,
    refetch: refetchCustomer,
  } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const {
    data: meetingAllData,
    isLoading: meetingAllIsLoading,
    refetch: refetchMeetings,
  } = useGetMeetingQuery({
    searchText: "",
    staffId: "",
    clientId: String(customerId),
    id: "",
    meeting_Date: "",
  });

  const {
    data: staffData,
    isLoading: staffIsLoading,
    refetch: refetchStaff,
  } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const {
    data: connectionRelationShipData,
    isLoading: connectionRelationShipIsLoading,
    refetch: connectionRelationShipRefetch,
    isError: connectionRelationShipIsError,
  } = useConnectionRelationShipQuery({
    policyCustomerId: String(customerId),
  });

  const { data: meetingAllSubjectData, isLoading: meetingAllSubjectIsLoading } =
    useGetAllMeetingSubjectQuery({
      searchText: "",
      id: "",
    });

  const { data: holydaysData, isLoading: holidaysIsLoading } =
    useGetAllHolydaysArrayQuery({
      searchText: "",
      id: "",
    });

  const { data: holydaysTitleData, isLoading: holidaysTitleIsLoading } =
    useGetAllHolydaysTitleQuery({
      searchText: "",
      id: "",
    });

  const { data: policyAllData, isLoading: policyAllIsLoading } =
    useGetAllPolicyGroupByQuery({
      searchText: "",
      id: "",
      policyCustomerId: "",
    });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetMeetingQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: selectedId || "",
      meeting_Date: "",
    },
    {
      skip: !selectedId,
    }
  );

  const {
    data: policyData,
    isLoading: policyIsLoading,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: selectedCustomerId,
  });

  const {
    data: getAllMeetingCategoryData,
    isLoading: meetingCategoryIsLoading,
  } = useGetMeetingCategoryQuery({
    searchText: "",
  });

  const policyCustomerId = String(customerId || "");

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetCustomerRelationQuery(
    { policyCustomerId },
    { skip: !policyCustomerId }
  );

  const {
    data: policyReportData,
    isLoading: policyReportIsLoading,
    isError: policyReportError,
  } = useGetCustomerPolicyReportQuery(
    { policyCustomerId },
    { skip: !policyCustomerId }
  );

  const [newEmail, { isLoading: createEmaliRecordLoading }] =
    useCreateClintEmailRecordMutation();

  const { data: emailRecodData, isLoading: emailRecordIsLoading } =
    useGetEmailRecordQuery({
      searchText: "",
      id: "",
      staffId: "",
      clientId: String(customerId),
    });

  const { data: clientTypeData, isLoading: cilentTypeIsLoading } =
    useGetClientTypeQuery({
      searchText: "",
      id: "",
    });

  const { data: userListData, isLoading: userIsLoading } =
    useGetUserInfoOnyQuery({
      searchText: "",
    });

  const [newSms, { isLoading: createSmsRecordLoading }] =
    useCreateClintSmsRecordMutation();

  const { data: smsRecodData, isLoading: smsRecordIsLoading } =
    useGetSmsRecordQuery({
      searchText: "",
      id: "",
      staffId: "",
      clientId: String(customerId),
    });

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const customerList = useMemo(() => {
    return customerDate?.data as ICustomer[];
  }, [customerDate?.data]);

  const cliendList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const allcliendList = useMemo(() => {
    return (allclientData?.data ?? []) as ICustomer[];
  }, [allclientData?.data]);

  const policyAllList = useMemo(() => {
    return (policyAllData?.data ?? []) as IPolicy[];
  }, [policyAllData?.data]);

  const policyList = useMemo(() => {
    return (policyData?.data ?? []) as IPolicy[];
  }, [policyData?.data]);

  const staffList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const meetingCategoryList = useMemo(() => {
    return (getAllMeetingCategoryData?.data ?? []) as IMeetingCategory2[];
  }, [getAllMeetingCategoryData?.data]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const emailRecordList = useMemo(() => {
    return emailRecodData?.data as IEmailRecords[];
  }, [emailRecodData?.data]);

  const smsRecordList = useMemo(() => {
    return smsRecodData?.data as ISmsRecords[];
  }, [smsRecodData?.data]);

  const cliendTypeList = useMemo(() => {
    return (clientTypeData?.data ?? []) as IClientType[];
  }, [clientTypeData?.data]);

  const clientTypeMap = useMemo(() => {
    const map = new Map();
    cliendTypeList?.forEach((category) => {
      map.set(category.id, toProperCase(category.client_type || ""));
    });
    return map;
  }, [cliendTypeList]);

  const cutomerMap = useMemo(() => {
    const map = new Map();
    customerList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [customerList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${toProperCase(item?.related_customer_name)}`);
    });
    return map;
  }, [relationDataList]);

  const relativeList = useMemo(() => {
    return relativeData?.data as ICustomerRelative[];
  }, [relativeData?.data]);

  const relatedCustomerIdMap = useMemo(() => {
    const map = new Map<number, number>();
    relationDataList?.forEach((item) => {
      if (item?.related_customer_id != null) {
        map.set(item.id, item.related_customer_id);
      }
    });
    return map;
  }, [relationDataList]);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);

  const project: IPolicy[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as IPolicy[];
    }
    return [];
  }, [customerProjectData]);

  const connectionRelationShip: IPolicy[] = useMemo(() => {
    if (
      connectionRelationShipData &&
      Array.isArray(connectionRelationShipData.data)
    ) {
      return connectionRelationShipData.data as IPolicy[];
    }
    return [];
  }, [connectionRelationShipData]);

  const meetingWithStaff: IMeeting[] = useMemo(() => {
    if (meetingAllData && Array.isArray(meetingAllData.data)) {
      return meetingAllData.data as IMeeting[];
    }
    return [];
  }, [meetingAllData]);

  const userList = useMemo(() => {
    return userListData?.data as IUserAdmin[];
  }, [userListData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(allcliendList)) return [];
    return allcliendList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [allcliendList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(staffList)) return [];
    return staffList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [staffList]);

  const meetingCategoryOptions = useMemo(() => {
    if (!Array.isArray(meetingCategoryList)) return [];
    return meetingCategoryList.map((cust) => ({
      label: `${cust.name}`,
      value: cust.id,
    }));
  }, [meetingCategoryList]);

  const policyOptions = useMemo(() => {
    if (!Array.isArray(policyList)) return [];
    return policyList.map((cust) => ({
      label: `${cust.policyNumber}`,
      value: cust.id,
    }));
  }, [policyList]);

  const clientMap = useMemo(() => {
    const map = new Map();
    allcliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [allcliendList]);

  const allPolicyMap = useMemo(() => {
    const map = new Map();
    policyAllList?.forEach((category) => {
      map.set(category.id, category.policyNumber);
    });
    return map;
  }, [policyAllList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const fristIndexMeeting = useMemo(() => {
    if (
      meetingData &&
      Array.isArray(meetingData.data) &&
      meetingData.data.length > 0
    ) {
      return meetingData.data[0] as IMeeting;
    }
    return null;
  }, [meetingData]);

  useEffect(() => {
    if (fristIndexMeeting) {
      setSelectedMeetingData(fristIndexMeeting);
    }
  }, [fristIndexMeeting, meetingLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedMeetingData?.id,
      staffId: selectedMeetingData?.staffId || "",
      clientId: selectedMeetingData?.clientId || "",
      subject: selectedMeetingData?.subject || "",
      note: selectedMeetingData?.note || "",
      meeting_time: selectedMeetingData?.meeting_time,
      meeting_Date: dayjs(selectedMeetingData?.meeting_Date.toString()),
      policyId: selectedMeetingData?.policyId,
      categoryId: selectedMeetingData?.categoryId,
      emailReminder: selectedMeetingData?.emailReminder || false,
      smsReminder: selectedMeetingData?.smsReminder || false,
      reminderBeforHours: selectedMeetingData?.reminderBeforHours || "",
      createNotification: selectedMeetingData?.createNotification || false,
      adminReminder: selectedMeetingData?.adminReminder || false,
    },
    onSubmit: async (values) => {
      try {
        const temData = {
          id: values?.id,
          clientId: values.clientId,
          staffId: values.staffId,
          subject: capitalizeFirstLetter(values.subject),
          meeting_time: values.meeting_time,
          meeting_Date: values.meeting_Date.format("YYYY-MM-DD"),
          note: values.note,
          policyId: values.policyId,
          categoryId: values.categoryId,
          emailReminder: Boolean(values.emailReminder),
          smsReminder: Boolean(values.smsReminder),
          reminderBeforHours: values.reminderBeforHours,
          createNotification: Boolean(values.createNotification),
          adminReminder: Boolean(values.adminReminder),
        };
        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleEditClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.staffId === "" ||
      // formik.values.clientId === "" ||
      formik.values.subject === "" ||
      !formik.values.meeting_Date ||
      formik.values.categoryId === "" ||
      !dayjs(formik.values.meeting_Date).isValid()
      ? false
      : true;
  }, [formik.values]);

  useEffect(() => {
    if (formik.values.clientId) {
      setSelectedCustomerId(formik.values.clientId);
      // formik.setFieldValue("policyId", "");
    }
  }, [formik.values.clientId]);

  useEffect(() => {
    const exists = policyOptions.some(
      (opt) => opt.value === Number(formik.values.policyId)
    );

    if (!exists && formik.values.policyId) {
      formik.setFieldValue("policyId", "");
    }
  }, [policyOptions, formik.values.policyId]);

  const formikEmail = useFormik({
    initialValues: {
      subject: "",
      message: "",
      toEmail: customer?.customerEmail || "",
      clientId: String(customerId),
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          clientId: values.clientId,
          subject: values.subject,
          message: values.message,
          toEmail: values.toEmail,
        };

        const addCompanyResponse = await newEmail(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          hadelSetValuFormik();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formikSms = useFormik({
    initialValues: {
      message: "",
      toMobileNumber: customer?.customerMobileNum || "",
      clientId: String(customerId),
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          clientId: values.clientId,
          message: values.message,
          toMobileNumber: values.toMobileNumber,
        };

        const addCompanyResponse = await newSms(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          hadelSetValueSmsFormik();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const hadelSetValuFormik = () => {
    formikEmail.setValues({
      toEmail: customer?.customerEmail || "",
      clientId: String(customerId),
      subject: "",
      message: "",
    });
  };

  const formValidEmail = useMemo(() => {
    return (
      formikEmail.values.toEmail &&
      formikEmail.values.clientId &&
      formikEmail.values.subject &&
      formikEmail.values.message
    );
  }, [formikEmail]);

  const hadelSetValueSmsFormik = () => {
    formikSms.setValues({
      toMobileNumber: customer?.customerMobileNum || "",
      clientId: String(customerId),
      message: "",
    });
  };

  const formValidSms = useMemo(() => {
    return (
      formikSms.values.toMobileNumber &&
      formikSms.values.clientId &&
      formikSms.values.message
    );
  }, [formikSms]);

  const toggleExpand = (id: string) => {
    setExpandedTemplateId((prev) => (prev === id ? null : id));
  };

  const toggleExpandHis = (id: number) => {
    setExpandedTemplateIdHis((prev) => (prev === id ? null : id));
  };

  const [deleteCategory] = useDeleteBasicsPolicyMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProject(false);
      } else {
        showErrorMessage("Failed to delete the Policy");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Policy");
    }
  };

  const [deleteMeeting] = useDeleteMeetingMutation();
  const handleDeleteMeeing = async (id: string) => {
    try {
      const response = await deleteMeeting(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the meeting");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting");
    }
  };

  const [deleteDoneMeeting] = useDoneMeetingMutation();
  const handleDeleteDoneMeeting = async (id: string) => {
    try {
      const response = await deleteDoneMeeting(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDoneMeeting(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting done");
    }
  };

  const [resentSmsforClient] = useResentSmsClientMutation();
  const handleResentSmsforClient = async (id: string) => {
    try {
      const response = await resentSmsforClient(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory2(false);
      } else {
        showMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resent");
    }
  };

  const [resentEmailforClient] = useResentEmailClientMutation();
  const handleResentEmailforClient = async (id: string) => {
    try {
      const response = await resentEmailforClient(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory23(false);
      } else {
        showMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resent");
    }
  };

  const getChangedFields = (
    current: IPolicy,
    prev: IPolicy | null,
    maps: {
      brandMap: Map<number, string>;
      relativeMap: Map<number, string>;
    }
  ) => {
    if (!prev) return [];

    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (field: keyof IPolicy, value: any): string => {
      if (value === undefined || value === null) return "-";

      switch (field) {
        case "policyIssueDate":
          return dayjs(value).format("MMM D, YYYY");
        case "policyPremiumFrequencyDate":
          return dayjs(value).format("MMM D, YYYY");
        case "contengentPolicyOwnerId":
          return maps.relativeMap.get(Number(value)) || `Category #${value}`;
        case "jointPolicyOwnerId":
          return maps.relativeMap.get(Number(value)) || `Category #${value}`;
        case "policyInsuranceCompanyId":
          return maps.brandMap.get(Number(value)) || `Category #${value}`;
        case "policyDrawDay":
          return `${value}`;
        case "policyPremiumFrequency":
          return `${value}`;
        case "policyPayor":
          return `${value}`;
        case "policyPayor":
          return `${value}`;
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IPolicy)[] = [
      "policyDrawDay",
      "policyPremiumFrequencyDate",
      "policyPremiumFrequency",
      "policyPremium",
      "policyIssueDate",
      "policyPayor",
      "contengentPolicyOwnerId",
      "jointPolicyOwnerId",
      "policyInsuranceCompanyId",
      "policyNumber",
      "policyOrderNumber",
    ];

    return fieldsToCheck
      .map((field) => {
        if (current[field] !== prev[field]) {
          return {
            field,
            oldValue: formatFieldValue(field, prev[field]),
            newValue: formatFieldValue(field, current[field]),
          };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof IPolicy;
      oldValue: string;
      newValue: string;
    }[];
  };

  const getCreatedFields = (
    current: IPolicy,
    maps: {
      brandMap: Map<number, string>;
      relativeMap: Map<number, string>;
    }
  ) => {
    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (field: keyof IPolicy, value: any): string => {
      if (value === undefined || value === null || value === "") return "";

      switch (field) {
        case "policyIssueDate":
          return dayjs(value).format("MMM D, YYYY");
        case "policyPremiumFrequencyDate":
          return dayjs(value).format("MMM D, YYYY");
        case "contengentPolicyOwnerId":
          return maps.relativeMap.get(Number(value)) || `Category #${value}`;
        case "jointPolicyOwnerId":
          return maps.relativeMap.get(Number(value)) || `Category #${value}`;
        case "policyInsuranceCompanyId":
          return maps.brandMap.get(Number(value)) || `Category #${value}`;
        case "policyDrawDay":
          return `${value}`;
        case "policyPremiumFrequency":
          return `${value}`;
        case "policyPayor":
          return `${value}`;
        case "policyPayor":
          return `${value}`;
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IPolicy)[] = [
      "policyDrawDay",
      "policyPremiumFrequencyDate",
      "policyPremiumFrequency",
      "policyPremium",
      "policyIssueDate",
      "policyPayor",
      "contengentPolicyOwnerId",
      "jointPolicyOwnerId",
      "policyInsuranceCompanyId",
      "policyNumber",
      "policyOrderNumber",
    ];

    return fieldsToCheck
      .map((field) => {
        const formatted = formatFieldValue(field, current[field]);
        if (formatted) {
          return { field, value: formatted };
        }
        return null;
      })
      .filter(Boolean) as { field: keyof IPolicy; value: string }[];
  };

  if (
    isLoading ||
    customerProjectDataIsLoading ||
    brandIsLoading ||
    relationIsLoading ||
    meetingAllIsLoading ||
    customerIsLoading ||
    staffIsLoading ||
    holidaysIsLoading ||
    policyAllIsLoading ||
    meetingAllSubjectIsLoading ||
    holidaysTitleIsLoading ||
    emailRecordIsLoading ||
    cilentTypeIsLoading ||
    userIsLoading ||
    smsRecordIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching customer data. Please try again later.
      </Typography>
    );
  }

  if (!customer) {
    return <Typography>No customer data available.</Typography>;
  }

  const coursings: ICustomerRelative[] = Array.isArray(relationData?.data)
    ? (relationData?.data as ICustomerRelative[])
    : [];

  const reportList: ICustomerReportList[] = Array.isArray(
    policyReportData?.data
  )
    ? (policyReportData?.data as ICustomerReportList[])
    : [];

  const handleOpenDeleteProjectPopup = (project: IPolicy) => {
    setProjectToDelete(project);
    setOpenDeleteProject(true);
  };

  const handleOpenDeletePopupMeeting = (coursing: ISmsRecords) => {
    setCoursingToDelete2(coursing);
    setOpenDeleteCategory2(true);
  };

  const handleCloseDeletePopupMeeting = () => {
    setCoursingToDelete2(null);
    setOpenDeleteCategory2(false);
  };

  const handleOpenDeletePopupMeeting3 = (coursing: IEmailRecords) => {
    setCoursingToDelete23(coursing);
    setOpenDeleteCategory23(true);
  };

  const handleCloseDeletePopupMeeting3 = () => {
    setCoursingToDelete23(null);
    setOpenDeleteCategory23(false);
  };

  const handleCloseDeleteProjectPopup = () => {
    setProjectToDelete(null);
    setOpenDeleteProject(false);
  };

  const handleOpenDialog = (coursing: ICustomer) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleOpenDialogMeeting = (coursing: IMeeting) => {
    setSelectedMeeting(coursing);
    setOpenDialogMeetingEdit(true);
  };

  const handleCloseDialogMeetingEdit = () => {
    setSelectedMeeting(null);
    setOpenDialogMeetingEdit(false);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleCloseDialogMeeting = () => {
    setOpenDialogMeeting(false);
    setIsPaperVisible(false);
    setSelectedDate(null);
  };

  const handleOpenDonePopup = (coursing: IMeeting) => {
    setMeetingToDone(coursing);
    setOpenDoneMeeting(true);
  };

  const handleCloseDonePopup = () => {
    setMeetingToDone(null);
    setOpenDoneMeeting(false);
  };

  const handleOpenDialogRelative = () => {
    setOpenAddProject(true);
  };

  const handleCloseDialogRelative = () => {
    setOpenAddProject(false);
  };

  const handleDateClick = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
      setOpenDialogMeeting(true);
    }
  };

  const handleOpenDialogMeetingRe = (coursing: IMeeting) => {
    setSelectedMeetingRe(coursing);
    setOpenDialogMeetingRe(true);
  };

  const handleCloseDialogMeetingRe = () => {
    setSelectedMeetingRe(null);
    setOpenDialogMeetingRe(false);
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleEditClose = () => {
    setOpenDrawer(false);
    setSelectedId("");
    setSelectedMeetingData(null);
  };

  const historyRecords: IPolicyHistoryRecords[] = Array.isArray(
    customerProjectHistoryData?.data
  )
    ? (customerProjectHistoryData?.data as IPolicyHistoryRecords[])
    : [];

  const viewMeetingProfile = () => {
    navigate(`/meeting/profile/${selectedMeetingData?.id}`);
  };

  const renderContent = () => {
    switch (activeSection) {
      case Section.Policy:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ minHeight: 200 }}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 1, padding: 2 }}
                  className={classes.activityHistoryHeaderGrid}
                >
                  <Grid
                    item
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      policy owned
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    lg={8}
                    md={8}
                    sm={8}
                    xs={8}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      {/* <Grid item>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CiSearch
                                  className={classes.searchWidgetIcon}
                                />
                              </InputAdornment>
                            ),
                            classes: {
                              root: classes.formControlList,
                            },
                          }}
                          fullWidth
                          value={searchQueryProject}
                          onChange={(e) =>
                            setSearchQueryProject(e.target.value)
                          }
                          placeholder="Name .."
                          sx={{ width: "100%" }}
                          size="small"
                        />
                      </Grid> */}
                      <Grid item>
                        <Link
                          to={`/customer-deals/${customerId}`}
                          className={classes.iconLinkPropNormal}
                        >
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            // endIcon={<AddIcon sx={{ fontSize: "32px" }} />}
                            onClick={() =>
                              navigate(`/customer-deals/${customerId}`)
                            }
                          >
                            Add Policy
                          </Button>
                        </Link>
                      </Grid>
                      {project.length > 0 && (
                        <Grid item>
                          <Link
                            to={`/summary-report/${customerId}`}
                            className={classes.iconLinkPropNormal}
                          >
                            <Button
                              // variant="contained"
                              className={classes.addNewButton}
                              onClick={() =>
                                navigate(`/summary-report/${customerId}`)
                              }
                            >
                              Generate Report
                            </Button>
                          </Link>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            Or.No
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            Policy Number
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            Insurance Company
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            Insured
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {customerProjectDataIsLoading ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="10vh"
                              >
                                <CircularProgress />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : cutomerProjectIsError || project.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          project.map((project: IPolicy) => (
                            <TableRow
                              key={project.id}
                              className={classes.tableRowHover}
                            >
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {project.policyOrderNumber}
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                className={classes.tablCell}
                              >
                                <Link
                                  to={`/customer/${project.policyCustomerId}/policy/${project.policyNumber}`}
                                  className={classes.iconLinkPropNormal}
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px",
                                    }}
                                  >
                                    {project.policyNumber}
                                    <FontAwesomeIcon
                                      icon={faLink}
                                      style={{ color: "#1976d2" }}
                                    />
                                  </span>
                                </Link>
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {/* {productMap.get(
                                    Number(project.policyProductId)
                                  ) || ""} */}

                                {brandMap.get(
                                  Number(project.policyInsuranceCompanyId)
                                ) || ""}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                              >
                                {project.allInsuredDetails.map(
                                  (insuredId, index) => {
                                    const customerName =
                                      relativeMap.get(Number(insuredId)) || "";

                                    return (
                                      <Link
                                        to={`/profile/customer/${relatedCustomerIdMap.get(
                                          Number(insuredId)
                                        )}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <div
                                          key={insuredId}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            const relative = relativeList.find(
                                              (c) => c.id === Number(insuredId)
                                            );
                                            if (relative?.related_customer_id) {
                                              navigate(
                                                `/profile/customer/${relative.related_customer_id}`
                                              );
                                            }
                                          }}
                                        >
                                          {customerName}
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              paddingLeft: "2px",
                                              paddingRight: "1px",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faUser}
                                              style={{
                                                color: "#1976d2",
                                              }}
                                            />
                                          </span>
                                          {index <
                                            project.allInsuredDetails.length -
                                              1 && ", "}
                                        </div>
                                      </Link>
                                    );
                                  }
                                )}
                              </TableCell>

                              <TableCell className={classes.tablCell}>
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid item>
                                    <Link
                                      to={`/customer/${project.policyCustomerId}/policy/${project.policyNumber}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        variant="contained"
                                        className={classes.viewButtonList}
                                        onClick={() =>
                                          navigate(
                                            `/customer/${project.policyCustomerId}/policy/${project.policyNumber}`
                                          )
                                        }
                                      >
                                        <VisibilityIcon
                                          className={classes.viewListIcon}
                                        />
                                      </Button>
                                    </Link>
                                  </Grid>
                                  <Grid item>
                                    <Link
                                      to={`/basic/deal/${project.id}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        variant="contained"
                                        className={classes.editButtonList}
                                        onClick={() =>
                                          navigate(`/basic/deal/${project.id}`)
                                        }
                                      >
                                        <EditSharpIcon
                                          className={classes.editListIcon}
                                        />
                                      </Button>
                                    </Link>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="contained"
                                      className={classes.deleteButtonList}
                                      onClick={() =>
                                        handleOpenDeleteProjectPopup(project)
                                      }
                                    >
                                      <DeleteOutlineSharpIcon
                                        className={classes.deleteListIcon}
                                      />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {projectToDelete && (
                    <DeletePopup
                      open={openDeleteProject}
                      handleCloseDelete={handleCloseDeleteProjectPopup}
                      onConfirm={async () => {
                        await handleDelete(
                          projectToDelete.policyNumber.toString()
                        );
                      }}
                      title="Delete Policy"
                      content={`Are you sure you want to delete "${projectToDelete.policyNumber}"?`}
                    />
                  )}
                </Grid>
              </Card>
            </Grid>
            {connectionRelationShip.length > 0 && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.stepperCard}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 1, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      lg={4}
                      md={4}
                      sm={4}
                      xs={4}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Insured
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                            <TableCell className={classes.tablheader}>
                              Policy Number
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              Policy Owner
                            </TableCell>
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {connectionRelationShipIsLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : connectionRelationShipIsError ||
                            connectionRelationShip.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                {isError
                                  ? "Error fetching data"
                                  : "No data available"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            connectionRelationShip.map((project: IPolicy) => (
                              <TableRow
                                key={project.id}
                                className={classes.tableRowHover}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Link
                                    to={`/customer/${project.policyCustomerId}/policy/${project.policyNumber}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/customer/${project.policyCustomerId}/policy/${project.policyNumber}`
                                        )
                                      }
                                    >
                                      {project.policyNumber}
                                      <FontAwesomeIcon
                                        icon={faLink}
                                        style={{ color: "#1976d2" }}
                                      />
                                    </span>
                                  </Link>
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Link
                                    to={`/profile/customer/${project.policyCustomerId}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/profile/customer/${project.policyCustomerId}`
                                        )
                                      }
                                    >
                                      {cutomerMap.get(project.policyCustomerId)}
                                      <FontAwesomeIcon
                                        icon={faUser}
                                        style={{ color: "#1976d2" }}
                                      />
                                    </span>
                                  </Link>
                                </TableCell>
                                <TableCell className={classes.tablCell}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Grid item>
                                      <Link
                                        to={`/customer/${project.policyCustomerId}/policy/${project.policyNumber}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Button
                                          variant="contained"
                                          className={classes.viewButtonList}
                                          onClick={() =>
                                            navigate(
                                              `/customer/${project.policyCustomerId}/policy/${project.policyNumber}`
                                            )
                                          }
                                        >
                                          <VisibilityIcon
                                            className={classes.viewListIcon}
                                          />
                                        </Button>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Card>
              </Grid>
            )}
            {historyRecords.length > 0 && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        History
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12} p={2}>
                    <Box
                      sx={{
                        // minHeight: "60vh",
                        maxHeight: "100vh",
                        overflow: "auto",
                        padding: "2px",
                        "&::-webkit-scrollbar": {
                          width: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#eeeeee",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#eeeeee",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#eeeeee",
                        },
                      }}
                    >
                      <Stack spacing={2}>
                        {historyRecords.map((order, index) => {
                          const statusName = order.updated_by
                            ? "Updated"
                            : "Created";

                          const statusNameIcon = order.updated_by
                            ? "ChangedStatusOrange"
                            : "ChangedStatusGreen";

                          const userName = userMap.get(order.created_by) || "";
                          return (
                            <Card
                              key={order.id}
                              variant="outlined"
                              className={classes.orderListRightCard2}
                            >
                              <CardContent>
                                <Stack
                                  spacing={1}
                                  mb={1}
                                  onClick={() => toggleExpandHis(order.id)}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ mb: 1 }}
                                  >
                                    <Typography variant="h6" fontWeight={600}>
                                      {dayjs(order.created_at).format(
                                        "MMM D, YYYY h:mm A"
                                      )}
                                    </Typography>

                                    <ExpandMore
                                      expand={
                                        expandedTemplateIdHis === order.id
                                      }
                                      onClick={() => toggleExpandHis(order.id)}
                                      aria-expanded={
                                        expandedTemplateIdHis === order.id
                                      }
                                    >
                                      <ExpandMoreIcon />
                                    </ExpandMore>
                                  </Stack>

                                  <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={1}
                                    flexWrap="wrap"
                                  >
                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {order.policyNumber}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {`| ${
                                        brandMap.get(
                                          Number(order.policyInsuranceCompanyId)
                                        ) || ""
                                      }`}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {` | ${userName}`}
                                    </Typography>
                                  </Stack>
                                  <>
                                    <Stack spacing={1} mb={1}>
                                      <Stack
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap="wrap"
                                      >
                                        {
                                          statusIcon[
                                            statusNameIcon as keyof typeof statusIcon
                                          ]
                                        }

                                        <Typography
                                          fontWeight={600}
                                          sx={{
                                            color:
                                              statusName === "Created"
                                                ? "green"
                                                : "orange",
                                          }}
                                        >
                                          <strong>{statusName}</strong>
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </>
                                </Stack>
                                <Stack spacing={1} mb={1}>
                                  {order.policyrecord_history.length > 0 ? (
                                    <Collapse
                                      in={expandedTemplateIdHis === order.id}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <Divider sx={{ mb: 2 }} />
                                      {/* Render 0th index as Created */}
                                      {(() => {
                                        const msg =
                                          order.policyrecord_history[0];
                                        const createdFields = getCreatedFields(
                                          msg,
                                          { brandMap, relativeMap }
                                        );

                                        return (
                                          <Box key={msg.id} pb={4}>
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              justifyContent="space-between"
                                              sx={{ mb: 1 }}
                                            >
                                              <Typography
                                                color="primary"
                                                style={{ fontWeight: 600 }}
                                              >
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                  gap={1}
                                                >
                                                  <PublishedWithChangesIcon
                                                    fontSize="medium"
                                                    color="primary"
                                                    style={{
                                                      fontSize: 20,
                                                      fontWeight: 600,
                                                    }}
                                                  />
                                                  {userMap.get(
                                                    msg.created_by
                                                  ) || ""}{" "}
                                                  created record:
                                                </Box>
                                              </Typography>

                                              <Typography variant="h6">
                                                {dayjs(msg.created_at).format(
                                                  "MMM D, YYYY h:mm A"
                                                )}
                                              </Typography>
                                            </Stack>

                                            {createdFields.map((item, idx) => (
                                              <Box key={idx} mb={2} ml={4}>
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  spacing={1}
                                                >
                                                  {statusIcon["Created"]}
                                                  <Typography variant="body2">
                                                    {variantPropName(
                                                      item.field
                                                    )}{" "}
                                                    added ➜ {item.value}
                                                  </Typography>
                                                </Stack>
                                              </Box>
                                            ))}
                                          </Box>
                                        );
                                      })()}

                                      {/* Render rest of the history (index > 0) as changes */}
                                      {order.policyrecord_history
                                        .slice(1)
                                        .map((msg, index) => {
                                          const prev =
                                            order.policyrecord_history[index]; // prev is previous record
                                          const changes =
                                            msg.status === "updated"
                                              ? getChangedFields(msg, prev, {
                                                  brandMap,
                                                  relativeMap,
                                                })
                                              : getChangedFields(msg, prev, {
                                                  brandMap,
                                                  relativeMap,
                                                });

                                          return (
                                            <Box key={msg.id} pb={4}>
                                              {changes &&
                                                changes.length > 0 && (
                                                  <>
                                                    <Stack
                                                      direction="row"
                                                      alignItems="center"
                                                      justifyContent="space-between"
                                                      sx={{ mb: 1 }}
                                                    >
                                                      <Typography
                                                        color="primary"
                                                        style={{
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        <Box
                                                          display="flex"
                                                          alignItems="center"
                                                          gap={1}
                                                        >
                                                          <PublishedWithChangesIcon
                                                            fontSize="medium"
                                                            color="primary"
                                                            style={{
                                                              fontSize: 20,
                                                              fontWeight: 600,
                                                            }}
                                                          />
                                                          {userMap.get(
                                                            msg.created_by
                                                          ) || ""}{" "}
                                                          made changes:
                                                        </Box>
                                                      </Typography>

                                                      <Typography variant="h6">
                                                        {dayjs(
                                                          msg.created_at
                                                        ).format(
                                                          "MMM D, YYYY h:mm A"
                                                        )}
                                                      </Typography>
                                                    </Stack>

                                                    {changes.map(
                                                      (change, idx) => {
                                                        const statusType =
                                                          getStatusType(
                                                            change.oldValue,
                                                            change.newValue
                                                          );

                                                        return (
                                                          <Box
                                                            key={idx}
                                                            mb={2}
                                                            ml={4}
                                                          >
                                                            <Stack
                                                              direction="row"
                                                              alignItems="center"
                                                              spacing={1}
                                                            >
                                                              {statusType &&
                                                                statusIcon[
                                                                  statusType
                                                                ]}
                                                              <Typography variant="body2">
                                                                {variantPropName(
                                                                  change.field
                                                                )}{" "}
                                                                {statusType ===
                                                                  "Created" && (
                                                                  <>
                                                                    added ➜{" "}
                                                                    {
                                                                      change.newValue
                                                                    }
                                                                  </>
                                                                )}
                                                                {statusType ===
                                                                  "Modified" && (
                                                                  <>
                                                                    changed from{" "}
                                                                    <s>
                                                                      {
                                                                        change.oldValue
                                                                      }
                                                                    </s>{" "}
                                                                    ➜{" "}
                                                                    {
                                                                      change.newValue
                                                                    }
                                                                  </>
                                                                )}
                                                                {statusType ===
                                                                  "Deleted" && (
                                                                  <>
                                                                    removed (was{" "}
                                                                    {
                                                                      change.oldValue
                                                                    }
                                                                    )
                                                                  </>
                                                                )}
                                                              </Typography>
                                                            </Stack>
                                                          </Box>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                )}
                                            </Box>
                                          );
                                        })}
                                    </Collapse>
                                  ) : (
                                    <Grid item xs={12}>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        No history available
                                      </Typography>
                                    </Grid>
                                  )}
                                </Stack>
                              </CardContent>
                            </Card>
                          );
                        })}
                      </Stack>
                    </Box>
                  </Grid>
                </Card>
              </Grid>
            )}
          </Grid>
        );
      case Section.Meeting:
        return (
          <div>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card} sx={{ minHeight: 500 }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        Meeting
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.addNewButton}
                            onClick={handleToggle}
                          >
                            {isPaperVisible ? "Close" : "Add New"}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} m={2} pt={4}>
                      <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        events={meetingWithStaff.map((meeting) => ({
                          id: String(meeting.id),
                          title: meeting.subject,
                          start: meeting.meeting_time
                            ? `${dayjs(meeting.meeting_Date).format(
                                "YYYY-MM-DD"
                              )}T${meeting.meeting_time}`
                            : dayjs(meeting.meeting_Date).format("YYYY-MM-DD"),
                          backgroundColor: meeting.meeting_category_color,
                          borderColor: meeting.meeting_category_color,
                          textColor: "#fff",
                          display: "block",
                          extendedProps: {
                            meeting_Date: meeting.meeting_Date,
                            meeting_time: meeting.meeting_time,
                            staffId: meeting.staffId,
                            clientId: meeting.clientId,
                            policyId: meeting.policyId,
                            subject: meeting.subject,
                          },
                        }))}
                        eventContent={(eventInfo) => {
                          const {
                            meeting_Date,
                            meeting_time,
                            staffId,
                            clientId,
                            policyId,
                            subject,
                          } = eventInfo.event.extendedProps;

                          const displayTitle =
                            eventInfo.event.title.length > 20
                              ? eventInfo.event.title.slice(0, 20) + "..."
                              : eventInfo.event.title;

                          return (
                            <Tooltip
                              placement="top"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "#f9f9f9",
                                    color: "#333",
                                    border: "1px solid #ccc",
                                    borderRadius: 2,
                                    boxShadow: 3,
                                    padding: 1.5,
                                    maxWidth: 500,
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: "#f9f9f9",
                                  },
                                },
                              }}
                              title={
                                <Grid container spacing={1}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      fontWeight="bold"
                                      fontSize={14}
                                      color="#0d47a1"
                                    >
                                      {subject || displayTitle}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    ml={3}
                                  >
                                    {meeting_Date && (
                                      <Typography fontSize={13}>
                                        <strong>Meeting Date:</strong>{" "}
                                        {dayjs(meeting_Date).format(
                                          "MMM DD, YYYY"
                                        )}
                                      </Typography>
                                    )}
                                    {meeting_time && (
                                      <Typography fontSize={13}>
                                        <strong>Meeting Time:</strong>{" "}
                                        {formatTime(meeting_time)}
                                      </Typography>
                                    )}
                                    {staffId && (
                                      <Typography fontSize={13}>
                                        <strong>Staff:</strong>{" "}
                                        {staffMap.get(Number(staffId)) || "—"}
                                      </Typography>
                                    )}
                                    {clientId && (
                                      <Typography fontSize={13}>
                                        <strong>Client:</strong>{" "}
                                        {clientMap.get(Number(clientId)) || "—"}
                                      </Typography>
                                    )}
                                    {policyId && (
                                      <Typography fontSize={13}>
                                        <strong>Policy:</strong>{" "}
                                        {allPolicyMap.get(Number(policyId)) ||
                                          "—"}
                                      </Typography>
                                    )}
                                  </Grid>
                                </Grid>
                              }
                            >
                              <div
                                style={{
                                  marginBottom: "6px",
                                  borderRadius: "4px",
                                  padding: "4px 8px",
                                  backgroundColor: eventInfo.backgroundColor,
                                  color: eventInfo.textColor,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  cursor: "pointer",
                                  // gap: 3
                                }}
                              >
                                {meeting_time
                                  ? `${formatTime(
                                      meeting_time
                                    )} - ${displayTitle}`
                                  : displayTitle}
                              </div>
                            </Tooltip>
                          );
                        }}
                        dateClick={(info: DateClickArg) => {
                          const clickedDate = dayjs(info.dateStr).format(
                            "YYYY-MM-DD"
                          );

                          const holiday = holydaysTitleData?.data?.find(
                            (h) =>
                              dayjs(h.date).format("YYYY-MM-DD") === clickedDate
                          );

                          if (holiday) {
                            setAlertMessage(
                              `This date is a holiday: ${
                                holiday.note?.trim() || "Holiday"
                              }`
                            );
                            setDeleteAlert(true);
                            return;
                          }

                          navigate(
                            `/client/meeting/client/create?date=${
                              info.dateStr
                            }&clientId=${String(customerId)}`
                          );
                        }}
                        eventClick={(info) => {
                          const eventId = info.event.id;
                          // navigate(`/meeting/profile/${eventId}`);
                          // console.log("Clicked event ID:", eventId);
                          setOpenDrawer(true);
                          setSelectedId(eventId);
                          // console.log("setSelectedId:", selectedId);
                        }}
                        dayCellDidMount={(arg) => {
                          arg.el.style.cursor = "pointer";

                          const cellDate = dayjs(arg.date).format("YYYY-MM-DD");

                          const holiday = holydaysTitleData?.data?.find(
                            (h) =>
                              dayjs(h.date).format("YYYY-MM-DD") === cellDate
                          );

                          if (holiday) {
                            arg.el.style.backgroundColor = "#ffeaea";
                            arg.el.style.position = "relative";

                            const label = document.createElement("div");
                            label.textContent = holiday.note?.trim()
                              ? holiday.note
                              : "Holiday";
                            label.style.position = "absolute";
                            label.style.top = "50%";
                            label.style.left = "50%";
                            label.style.transform = "translate(-50%, -50%)";
                            label.style.fontSize = "12px";
                            label.style.fontWeight = "bold";
                            label.style.color = "#b71c1c";
                            // label.style.backgroundColor = "#fff0f0";
                            label.style.padding = "2px 6px";
                            label.style.borderRadius = "4px";
                            label.style.pointerEvents = "none";

                            arg.el.appendChild(label);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Info:
        return (
          <div>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        Profile
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                          <Button
                            // variant="contained"
                            className={classes.editButtonListProfile}
                            onClick={() => handleOpenDialog(customer)}
                          >
                            <EditSharpIcon
                              className={classes.editListIconProfileAddColor}
                            />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2} sx={{ padding: 2 }}>
                        {(customer.customerFirstName ||
                          customer.customerLastName ||
                          customer.customerRefId ||
                          customer.customerClientId ||
                          customer.customerEmail ||
                          customer.customerMobileNum ||
                          customer.customerWorkMobileNum ||
                          customer.customerHomeMobileNum) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography className={classes.cardTitle}>
                                        Client Details
                                      </Typography>
                                    </Grid> */}
                                    {(customer.customerFirstName ||
                                      customer.customerLastName) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Full Name
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {`${toProperCase(
                                              customer.customerFirstName || ""
                                            )} ${toProperCase(
                                              customer.customerLastName || ""
                                            )}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerRefId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Client Id
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerRefId}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      container
                                      spacing={1}
                                    >
                                      <Grid item lg={4} md={4} sm={4} xs={4}>
                                        <Typography
                                          className={classes.customerDetails}
                                        >
                                          Is Parent
                                          <span style={{ float: "right" }}>
                                            :
                                          </span>
                                        </Typography>
                                      </Grid>
                                      <Grid item lg={8} md={8} sm={8} xs={8}>
                                        <Typography>
                                          {customer.isPerent ? "Yes" : "No"}
                                        </Typography>
                                      </Grid>
                                    </Grid>

                                    {customer.customerClientId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Client Type
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {clientTypeMap.get(
                                              Number(customer.customerClientId)
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerEmail && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            E-mail
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerEmail.toLowerCase()}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerMobileNum && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Call
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {formatPhoneNumberForDisplay(
                                              customer.customerMobileNum
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerWorkMobileNum && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Work
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {formatPhoneNumberForDisplay(
                                              customer.customerWorkMobileNum
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerHomeMobileNum && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Home
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {formatPhoneNumberForDisplay(
                                              customer.customerHomeMobileNum
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {(customer.customerPreferTimeToCall ||
                          customer.customerClientStatusId ||
                          customer.customerClientSource ||
                          customer.customerContactStage ||
                          customer.customerClientSource ||
                          customer.customerHeight ||
                          customer.referredByIds.length > 0) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {customer.customerPreferTimeToCall && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Prefer Time to call
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {capitalizeFirstLetter(
                                              customer.customerPreferTimeToCall
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerClientStatusId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Client Status
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerClientStatusId
                                              ? getClientStatus(
                                                  customer.customerClientStatusId
                                                )
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerClientSource && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Client Source
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerClientSource
                                              ? getClientSource(
                                                  customer.customerClientSource
                                                )
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerContactStage && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Contact Stage
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {toProperCase(
                                              customer.customerContactStage
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {(customer.customerHeight ||
                                      customer.referredByIds.length > 0) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Referred by
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          {customer.referredByIds &&
                                            customer.referredByIds.length >
                                              0 && (
                                              <Typography>
                                                {customer.referredByIds.map(
                                                  (insuredId, index) => {
                                                    const customerName =
                                                      cutomerMap.get(
                                                        Number(insuredId)
                                                      ) || "";

                                                    return (
                                                      <Link
                                                        key={insuredId}
                                                        to={`/profile/customer/${insuredId}`}
                                                        className={
                                                          classes.iconLinkPropNormal
                                                        }
                                                      >
                                                        <div
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          // onClick={() => {
                                                          //   navigate(
                                                          //     `/profile/customer/${insuredId}`
                                                          //   );
                                                          // }}
                                                        >
                                                          {customerName}
                                                          <span
                                                            className={
                                                              classes.customerDetails
                                                            }
                                                            style={{
                                                              display:
                                                                "inline-flex",
                                                              alignItems:
                                                                "center",
                                                              paddingLeft:
                                                                "6px",
                                                            }}
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faUser}
                                                              style={{
                                                                color:
                                                                  "#1976d2",
                                                              }}
                                                            />
                                                          </span>
                                                          {index <
                                                            customer
                                                              .referredByIds
                                                              .length -
                                                              1 && ", "}
                                                        </div>
                                                      </Link>
                                                    );
                                                  }
                                                )}
                                              </Typography>
                                            )}

                                          <Typography>
                                            {toProperCase(
                                              customer.customerHeight
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {(customer.customerAddresLine ||
                          customer.customerCity ||
                          customer.customerProvince ||
                          customer.customerPostalCode ||
                          customer.customerPreAddress) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {(customer.customerAddresLine ||
                                      customer.customerCity ||
                                      customer.customerProvince ||
                                      customer.customerPostalCode) && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Primary Address
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {toProperCase(
                                              customer.customerAddresLine
                                            )}
                                          </Typography>
                                          <Typography>
                                            {customer?.customerCity
                                              ? `${toProperCase(
                                                  customer.customerCity
                                                )}, `
                                              : ""}
                                            {customer?.customerPostalCode
                                              ? `${toAllCaps(
                                                  customer.customerProvince
                                                )} `
                                              : ""}
                                            {customer?.customerPostalCode
                                              ? `${toAllCaps(
                                                  customer.customerPostalCode
                                                )}`
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerPreAddress && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Preview Address
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {capitalizeFirstLetter(
                                              customer.customerPreAddress
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {(customer.customerDateOfBirth ||
                          customer.customerMaritalStatusId ||
                          customer.customerGenderId) && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {customer.customerDateOfBirth && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Date Of Birth
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerDateOfBirth
                                              ? dayjs(
                                                  customer.customerDateOfBirth
                                                ).format("MMM D, YYYY")
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerGenderId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Gender
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerGenderId
                                              ? getGenderLabel(
                                                  customer.customerGenderId
                                                )
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {customer.customerMaritalStatusId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Marital Status
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerMaritalStatusId
                                              ? getMaritalStatusLabel(
                                                  customer.customerMaritalStatusId
                                                )
                                              : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {customer.customerRemark && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    {customer.customerRemark && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid item lg={4} md={4} sm={4} xs={4}>
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Remark
                                            <span style={{ float: "right" }}>
                                              :
                                            </span>
                                          </Typography>
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8} xs={8}>
                                          <Typography>
                                            {customer.customerRemark}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}

                        {project.length > 0 && (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={2} p={2}>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container spacing={1}>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      container
                                      spacing={1}
                                    >
                                      <Grid item lg={4} md={4} sm={4} xs={4}>
                                        <Typography
                                          className={classes.customerDetails}
                                        >
                                          Policy
                                          <span style={{ float: "right" }}>
                                            :
                                          </span>
                                        </Typography>
                                      </Grid>
                                      <Grid item lg={8} md={8} sm={8} xs={8}>
                                        <Grid container spacing={1}>
                                          {project.map((project: IPolicy) => (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              key={project.id}
                                            >
                                              <Typography>
                                                <Link
                                                  to={`/customer/${project.policyCustomerId}/policy/${project.policyNumber}`}
                                                  className={
                                                    classes.iconLinkPropNormal
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                  >
                                                    {project.policyNumber}
                                                    {project.policyInsuranceCompanyId ? (
                                                      <>
                                                        {" "}
                                                        {"("}
                                                        {brandMap.get(
                                                          Number(
                                                            project.policyInsuranceCompanyId
                                                          )
                                                        ) || ""}
                                                        {")"}
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <FontAwesomeIcon
                                                      icon={faLink}
                                                      style={{
                                                        color: "#1976d2",
                                                      }}
                                                    />
                                                  </span>
                                                </Link>
                                              </Typography>
                                            </Grid>
                                          ))}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>

                    {selectedCoursing && (
                      <NewPopUpCustomer
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedCoursing}
                      />
                    )}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Email:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <form onSubmit={formikEmail.handleSubmit}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography className={classes.cardTitle}>
                            Email
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                To{" "}
                                <span className={classes.requiedfield}>*</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="To email"
                                size="small"
                                {...formikEmail.getFieldProps("toEmail")}
                                className={classes.textField}
                                InputProps={{
                                  readOnly: true,
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Subject{" "}
                                <span className={classes.requiedfield}>*</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Subject"
                                size="small"
                                multiline
                                rows={3}
                                {...formikEmail.getFieldProps("subject")}
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Message{" "}
                                <span className={classes.requiedfield}>*</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              {/* <TextField
                                  placeholder="message"
                                  size="small"
                                  multiline
                                  rows={5}
                                  {...formikEmail.getFieldProps("message")}
                                  className={classes.textField}
                                  InputProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                /> */}
                              <ReactQuill
                                value={formikEmail.values.message}
                                onChange={(value) =>
                                  formikEmail.setFieldValue("message", value)
                                }
                                placeholder="Type your message..."
                                theme="snow"
                                style={{ height: widthofReactQuill["400px"] }}
                                modules={{
                                  toolbar: [
                                    [{ font: [] }],
                                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                    ["bold", "italic", "underline", "strike"],
                                    [{ color: [] }, { background: [] }],
                                    [{ script: "sub" }, { script: "super" }],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    [{ indent: "-1" }, { indent: "+1" }],
                                    [{ direction: "rtl" }],
                                    [{ align: [] }],
                                    ["blockquote", "code-block"],
                                    ["link", "image", "video"],
                                    ["clean"],
                                  ],
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={5}>
                          <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                          >
                            <Grid
                              item
                              lg={4}
                              md={6}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            ></Grid>
                            <Grid
                              item
                              lg={8}
                              md={6}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={() => hadelSetValuFormik()}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>

                              <Button
                                variant="contained"
                                startIcon={
                                  createEmaliRecordLoading ? (
                                    <CircularProgress
                                      size={18}
                                      className={classes.isLoading}
                                    />
                                  ) : (
                                    <AddIcon />
                                  )
                                }
                                className={classes.addButton}
                                onClick={() => formikEmail.handleSubmit()}
                                disabled={
                                  !formValidEmail || createEmaliRecordLoading
                                }
                              >
                                Create
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card} sx={{ minHeight: 400 }}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={3}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      History
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={3} p={2}>
                  {emailRecordList?.length ? (
                    emailRecordList.map((template) => (
                      <Grid item xs={12} md={12} lg={12} key={template.id}>
                        <Card variant="outlined" className={classes.card}>
                          <CardContent
                            onClick={() => toggleExpand(template.id)}
                            sx={{ cursor: "pointer" }}
                          >
                            {/* Header Row: To Email + Expand Icon */}
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  To: {template.toEmail}
                                </Typography>
                              </Grid>
                              {/* <Grid item>
                                <ExpandMore
                                  expand={expandedTemplateId === template.id}
                                  onClick={() => toggleExpand(template.id)}
                                  aria-expanded={
                                    expandedTemplateId === template.id
                                  }
                                >
                                  <ExpandMoreIcon />
                                </ExpandMore>
                              </Grid> */}
                              {template?.created_at && template?.created_by && (
                                <Grid item>
                                  <Grid
                                    container
                                    spacing={1}
                                    direction="column"
                                  >
                                    <Grid item>
                                      <Typography
                                        variant="subtitle1"
                                        color="textSecondary"
                                      >
                                        {`${
                                          dayjs(template?.created_at).format(
                                            "MMM-D, YYYY hh:mm A"
                                          ) || ""
                                        } | ${userMap.get(
                                          template?.created_by
                                        )}`}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>

                            {/* Subject and Status */}
                            <Grid
                              container
                              spacing={1}
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item xs={12} sm={8}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  noWrap
                                >
                                  Subject: {template.subject}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm="auto">
                                {template.status === "Sent" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CheckCircleIcon
                                        sx={{ color: "green" }}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="green">
                                        Sent Successfully
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status === "Failed" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CancelIcon sx={{ color: "red" }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="error">
                                        Failed to Send
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : null}
                              </Grid>
                              {template.status !== "Sent" && (
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{
                                    mt: 4,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid item>
                                    {template.status !== "Sent" && (
                                      <Button
                                        variant="contained"
                                        className={classes.addButton}
                                        startIcon={<ReplayIcon />}
                                        onClick={() =>
                                          handleOpenDeletePopupMeeting3(
                                            template
                                          )
                                        }
                                        disabled={!customer?.customerEmail}
                                      >
                                        Resent
                                      </Button>
                                    )}

                                    {!customer?.customerEmail && (
                                      <div>
                                        <Typography
                                          sx={{
                                            fontStyle: "italic",
                                            color: "#a75252",
                                            fontWeight: 550,
                                          }}
                                          color="textSecondary"
                                          variant="body2"
                                        >
                                          -- No email number found for client --
                                        </Typography>
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>

                          <Collapse
                            in={expandedTemplateId === template.id}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Divider />
                            <CardContent>
                              <Typography
                                component="div"
                                dangerouslySetInnerHTML={{
                                  __html: template.message,
                                }}
                              />
                            </CardContent>
                          </Collapse>
                        </Card>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Typography textAlign="center">
                        No emails found.
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                {coursingToDelete23 && (
                  <ResentPopup
                    open={openDeleteCategory23}
                    handleCloseDelete={handleCloseDeletePopupMeeting3}
                    onConfirm={async () => {
                      await handleResentEmailforClient(
                        coursingToDelete23.id.toString()
                      );
                    }}
                    title="Resent E-mail"
                    content={`Are you sure you want to resent e-mail "${customer.customerEmail}"?`}
                  />
                )}
              </Card>
            </Grid>
          </Grid>
        );
      case Section.Sms:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <form onSubmit={formikSms.handleSubmit}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography className={classes.cardTitle}>
                            Sms
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3} p={"24px"}>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                To{" "}
                                <span className={classes.requiedfield}>*</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="To mobile number"
                                size="small"
                                value={formatPhoneNumberForDisplay(
                                  customer.customerMobileNum
                                )}
                                className={classes.textField}
                                InputProps={{
                                  readOnly: true,
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Message{" "}
                                <span className={classes.requiedfield}>*</span>
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Message"
                                size="small"
                                multiline
                                rows={10}
                                {...formikSms.getFieldProps("message")}
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} pt={5}>
                          <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                          >
                            <Grid
                              item
                              lg={4}
                              md={6}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            ></Grid>
                            <Grid
                              item
                              lg={8}
                              md={6}
                              sm={12}
                              xs={12}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={() => hadelSetValueSmsFormik()}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>

                              <Button
                                variant="contained"
                                startIcon={
                                  createSmsRecordLoading ? (
                                    <CircularProgress
                                      size={18}
                                      className={classes.isLoading}
                                    />
                                  ) : (
                                    <AddIcon />
                                  )
                                }
                                className={classes.addButton}
                                onClick={() => formikSms.handleSubmit()}
                                disabled={
                                  !formValidSms || createSmsRecordLoading
                                }
                              >
                                Create
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card} sx={{ minHeight: 400 }}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={3}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      History
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={3} p={2}>
                  {smsRecordList?.length ? (
                    smsRecordList.map((template) => (
                      <Grid item xs={12} md={12} lg={12} key={template.id}>
                        <Card variant="outlined" className={classes.card}>
                          <CardContent
                            onClick={() => toggleExpand(template.id)}
                            sx={{ cursor: "pointer" }}
                          >
                            {/* Header Row: To Email + Expand Icon */}
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  To:{" "}
                                  {formatPhoneNumberForDisplay(
                                    template.toMobileNumber
                                  )}
                                </Typography>
                              </Grid>
                              {template?.created_at && template?.created_by && (
                                <Grid item>
                                  <Grid
                                    container
                                    spacing={1}
                                    direction="column"
                                  >
                                    <Grid item>
                                      <Typography
                                        variant="subtitle1"
                                        color="textSecondary"
                                      >
                                        {`${
                                          dayjs(template?.created_at).format(
                                            "MMM-D, YYYY hh:mm A"
                                          ) || ""
                                        } | ${userMap.get(
                                          template?.created_by
                                        )}`}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>

                            <Grid
                              container
                              spacing={1}
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item xs={12} sm={8}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  noWrap
                                >
                                  Message: {template.message}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm="auto">
                                {template.status === "Sent" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CheckCircleIcon
                                        sx={{ color: "green" }}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="green">
                                        Sent Successfully
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : template.status === "Failed" ? (
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item>
                                      <CancelIcon sx={{ color: "red" }} />
                                    </Grid>
                                    <Grid item>
                                      <Typography variant="body2" color="error">
                                        Failed to Send
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : null}
                              </Grid>
                            </Grid>
                            {template.status !== "Sent" && (
                              <Grid
                                container
                                spacing={1}
                                sx={{
                                  mt: 4,
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid item>
                                  {template.status !== "Sent" && (
                                    <Button
                                      variant="contained"
                                      className={classes.addButton}
                                      startIcon={<ReplayIcon />}
                                      onClick={() =>
                                        handleOpenDeletePopupMeeting(template)
                                      }
                                      disabled={!customer?.customerMobileNum}
                                    >
                                      Resent
                                    </Button>
                                  )}

                                  {!customer?.customerMobileNum && (
                                    <div>
                                      <Typography
                                        sx={{
                                          fontStyle: "italic",
                                          color: "#a75252",
                                          fontWeight: 550,
                                        }}
                                        color="textSecondary"
                                        variant="body2"
                                      >
                                        -- No mobile number found for client --
                                      </Typography>
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            )}
                          </CardContent>
                        </Card>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Typography textAlign="center">No sms found.</Typography>
                    </Grid>
                  )}
                </Grid>
                {coursingToDelete2 && (
                  <ResentPopup
                    open={openDeleteCategory2}
                    handleCloseDelete={handleCloseDeletePopupMeeting}
                    onConfirm={async () => {
                      await handleResentSmsforClient(
                        coursingToDelete2.id.toString()
                      );
                    }}
                    title="Resent Sms"
                    content={`Are you sure you want to resent sms "${customer.customerMobileNum}"?`}
                  />
                )}
              </Card>
            </Grid>
          </Grid>
        );
      case Section.Task:
        return (
          <Grid container spacing={2}>
            {customerId && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <ClientListPouup clientTakeId={String(customerId)} />
              </Grid>
            )}
          </Grid>
        );
      default:
        return null;
    }
  };

  const isAnyLoading =
    isLoading ||
    customerProjectDataIsLoading ||
    brandIsLoading ||
    relationIsLoading ||
    meetingAllIsLoading ||
    customerIsLoading ||
    staffIsLoading ||
    customerProjectDataHistoryIsLoading;

  if (isAnyLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.profileBottomSetUp}
                  >
                    <Grid className={classes.profileBottomDwon}>
                      {customer ? (
                        customer.customerImg ? (
                          <img
                            src={customer.customerImg}
                            alt="Profile"
                            className={classes.profileImage}
                          />
                        ) : (
                          <Avatar
                            alt="Travis Howard"
                            src={AvatarImg}
                            className={classes.profileImage}
                          />
                        )
                      ) : (
                        <Avatar
                          alt="Travis Howard"
                          src={AvatarImg}
                          className={classes.profileImage}
                        />
                      )}
                    </Grid>
                    <Grid className={classes.buttonGroupList}>
                      <Typography
                        variant="h4"
                        className={classes.profileDetailItemList}
                      >
                        {toProperCase(customer.customerFirstName || "") +
                          " " +
                          toProperCase(customer.customerLastName || "")}
                      </Typography>
                      {customer.customerRefId && (
                        <Typography variant="subtitle1" sx={{ px: "3px" }}>
                          <span className={classes.customerDetails}>
                            {` (${customer.customerRefId})`}
                          </span>{" "}
                        </Typography>
                      )}
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      className={classes.buttonGroupList}
                    >
                      {customer.customerMobileNum && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.customerMobileNum && (
                              <span className={classes.iconText}>
                                {formatPhoneNumberForDisplaySpace(
                                  customer.customerMobileNum
                                )}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {customer.customerEmail && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.customerEmail && (
                              <span className={classes.iconText}>
                                {customer.customerEmail?.toLowerCase()}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>

                    <Grid>
                      <Grid className={classes.buttonGroup}>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.Policy)
                            }
                          >
                            <PolicyOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Policy
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Info)}
                          >
                            <InfoOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Profile
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Email)}
                          >
                            <EmailOutlined />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Email
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Sms)}
                          >
                            <SmsOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Sms
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Task)}
                          >
                            <AddTaskIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Task
                          </Typography>
                        </div>
                        {/* <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Note)}
                          >
                            <EditNoteOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Note
                          </Typography>
                        </div>
                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.History)
                            }
                          >
                            <HistoryIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            History
                          </Typography>
                        </div>

                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() => handleContainerChange(Section.Todo)}
                          >
                            <CheckCircleOutlineOutlinedIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Todo
                          </Typography>
                        </div> */}

                        <div className={classes.buttonItem}>
                          <Button
                            className={classes.editButtonProfile}
                            onClick={() =>
                              handleContainerChange(Section.Meeting)
                            }
                          >
                            <EventIcon />
                          </Button>
                          <Typography className={classes.buttonLabel}>
                            Meeting
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {renderContent()}
            </Grid>
          </Grid>
        </Grid>

        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 3, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        <Typography className={classes.cardTitle}>
                          Client Details
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid container spacing={1} justifyContent="flex-end">
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.editButtonListProfile}
                              onClick={() => handleOpenDialog(customer)}
                            >
                              <EditSharpIcon
                                className={classes.editListIconProfileAddColor}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2} sx={{ padding: 2 }}>
                          {customer.customerClientId && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Card className={classes.meetingLable1}>
                                <Grid container spacing={2} p={2}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={1}>
                                      {customer.customerClientId && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              Client Type
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {clientTypeMap.get(
                                                Number(
                                                  customer.customerClientId
                                                )
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          )}
                          {customer.customerClientId && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Card className={classes.meetingLable1}>
                                <Grid container spacing={2} p={2}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={1}>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        container
                                        spacing={1}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography
                                            className={classes.customerDetails}
                                          >
                                            Is Parent
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography>
                                            {customer.isPerent ? "Yes" : "No"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          )}

                          {(customer.customerAddresLine ||
                            customer.customerCity ||
                            customer.customerProvince ||
                            customer.customerPostalCode ||
                            customer.customerPreAddress) && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Card className={classes.meetingLable1}>
                                <Grid container spacing={2} p={2}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={1}>
                                      {(customer.customerAddresLine ||
                                        customer.customerCity ||
                                        customer.customerProvince ||
                                        customer.customerPostalCode) && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              Primary Address
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {toProperCase(
                                                customer.customerAddresLine
                                              )}
                                            </Typography>
                                            <Typography>
                                              {customer?.customerCity
                                                ? `${toProperCase(
                                                    customer.customerCity
                                                  )}, `
                                                : ""}
                                              {customer?.customerPostalCode
                                                ? `${toAllCaps(
                                                    customer.customerProvince
                                                  )} `
                                                : ""}
                                              {customer?.customerPostalCode
                                                ? `${toAllCaps(
                                                    customer.customerPostalCode
                                                  )}`
                                                : ""}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          )}

                          {(customer.customerEmail ||
                            customer.customerMobileNum ||
                            customer.customerWorkMobileNum ||
                            customer.customerHomeMobileNum) && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Card className={classes.meetingLable1}>
                                <Grid container spacing={2} p={2}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={3}>
                                      {customer.customerMobileNum && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              Call
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {formatPhoneNumberForDisplay(
                                                customer.customerMobileNum
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}

                                      {customer.customerWorkMobileNum && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              Work
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {formatPhoneNumberForDisplay(
                                                customer.customerWorkMobileNum
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}

                                      {customer.customerHomeMobileNum && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              Home
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {formatPhoneNumberForDisplay(
                                                customer.customerHomeMobileNum
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}

                                      {customer.customerEmail && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography
                                              className={
                                                classes.customerDetails
                                              }
                                            >
                                              E-mail
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Typography>
                                              {customer.customerEmail.toLowerCase()}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Card>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>

                      {selectedCoursing && (
                        <NewPopUpCustomer
                          openModel={openDialog}
                          handleCloseDialog={handleCloseDialog}
                          data={selectedCoursing}
                        />
                      )}
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* {coursings.filter(
              (row: ICustomerRelative) => row.relationship_type !== "Self"
            ).length > 0 && ( */}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card} sx={{ minHeight: 300 }}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 3, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        <Typography className={classes.cardTitle}>
                          Relative
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid container spacing={1} justifyContent="flex-end">
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.editButtonListProfile}
                              onClick={handleOpenDialogRelative}
                            >
                              <EditSharpIcon
                                className={classes.editListIconProfileAddColor}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box
                          sx={{
                            // minHeight: "60vh",
                            maxHeight: "70vh",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                          <Grid container spacing={2} sx={{ padding: 2 }}>
                            {relationIsLoading ? (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "200px",
                                }}
                              >
                                <CircularProgress />
                              </Grid>
                            ) : relationIsError || coursings.length === 0 ? (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "200px",
                                }}
                              >
                                <Typography>
                                  {relationIsError
                                    ? "Error fetching data"
                                    : "No data available"}
                                </Typography>
                              </Grid>
                            ) : (
                              coursings
                                .filter(
                                  (row: ICustomerRelative) =>
                                    row.relationship_type !== "Self"
                                )
                                .map((row: ICustomerRelative, index) => {
                                  const isReverse =
                                    row.itemcategory === "reverse";
                                  const primaryId = isReverse
                                    ? Number(row.customer_id)
                                    : Number(row.related_customer_id);

                                  return (
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      key={index}
                                    >
                                      <Card className={classes.meetingLable1}>
                                        <Grid container spacing={2} p={2}>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid container spacing={1}>
                                              <Grid
                                                item
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                                container
                                                spacing={"3px"}
                                              >
                                                {/* Primary Customer Link */}
                                                <Grid item>
                                                  <Typography variant="subtitle1">
                                                    <Link
                                                      to={`/profile/customer/${primaryId}`}
                                                      className={
                                                        classes.iconLinkPropBold
                                                      }
                                                    >
                                                      {cutomerMap.get(
                                                        primaryId
                                                      )}
                                                      <span
                                                        className={
                                                          classes.customerDetails
                                                        }
                                                        style={{
                                                          display:
                                                            "inline-flex",
                                                          alignItems: "center",
                                                          paddingLeft: "6px",
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faUser}
                                                          style={{
                                                            color: "#1976d2",
                                                          }}
                                                        />
                                                      </span>
                                                    </Link>
                                                  </Typography>
                                                </Grid>

                                                {/* Relationship Link */}
                                                {row.relationship_type && (
                                                  <Grid item>
                                                    <Typography variant="subtitle1">
                                                      <Link
                                                        to={`/profile/customer/${row.customer_id}`}
                                                        className={
                                                          classes.iconLinkPropNormal
                                                        }
                                                      >
                                                        ({row.relationship_type}{" "}
                                                        of{" "}
                                                        {cutomerMap.get(
                                                          Number(
                                                            row.customer_id
                                                          )
                                                        )}
                                                        {/* <span
                                                        className={
                                                          classes.customerDetails
                                                        }
                                                        style={{
                                                          display:
                                                            "inline-flex",
                                                          alignItems: "center",
                                                          paddingLeft: "6px",
                                                        }}
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faUser}
                                                          style={{
                                                            color: "#1976d2",
                                                          }}
                                                        />
                                                      </span> */}
                                                        )
                                                      </Link>
                                                    </Typography>
                                                  </Grid>
                                                )}
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  );
                                })
                            )}
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {openAddProject && (
                  <NewPopUpRelative
                    openModel={openAddProject}
                    handleCloseDialog={handleCloseDialogRelative}
                    // data={coursings}
                    customerClientId={String(customerId)}
                  />
                )}
              </Grid>
            </Grid>
            {/* )} */}

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card} sx={{ minHeight: 300 }}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 3, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        <Typography className={classes.cardTitle}>
                          Reports
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box
                          sx={{
                            // minHeight: "60vh",
                            maxHeight: "50vh",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                          <Grid container spacing={2} sx={{ padding: 2 }}>
                            {policyReportIsLoading ? (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "200px",
                                }}
                              >
                                <CircularProgress />
                              </Grid>
                            ) : policyReportError || reportList.length === 0 ? (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "200px",
                                }}
                              >
                                <Typography>
                                  {policyReportError
                                    ? "Error fetching data"
                                    : "No data available"}
                                </Typography>
                              </Grid>
                            ) : (
                              reportList.map(
                                (row: ICustomerReportList, index) => {
                                  return (
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      key={index}
                                    >
                                      <Card className={classes.meetingLable1}>
                                        <Grid
                                          container
                                          spacing={2}
                                          p={1}
                                          alignItems="center"
                                        >
                                          {/* PDF Link */}
                                          <Grid item xs={12} sm={6}>
                                            <a
                                              href={row.pdfs_path}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                textDecoration: "none",
                                                color: "#1976d2",
                                              }}
                                            >
                                              Download PDF
                                            </a>
                                          </Grid>

                                          <Grid item xs={12} sm={6}>
                                            <Typography
                                              color="textSecondary"
                                              sx={{
                                                fontSize: "11px",
                                                fontWeight: 600,
                                                textAlign: "right",
                                              }}
                                            >
                                              {`${
                                                dayjs(row?.created_at).format(
                                                  "MMM-D, YYYY hh:mm A"
                                                ) || ""
                                              } | ${userMap.get(
                                                row?.created_by
                                              )}`}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Card>
                                    </Grid>
                                  );
                                }
                              )
                            )}
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {openAddProject && (
                  <NewPopUpRelative
                    openModel={openAddProject}
                    handleCloseDialog={handleCloseDialogRelative}
                    // data={coursings}
                    customerClientId={String(customerId)}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={handleEditClose}
          PaperProps={{
            sx: {
              width: isMobile ? "100vw" : 600,
              maxWidth: "100vw",
              backgroundColor: theme.palette.background.default,
              padding: isMobile ? 1 : 2,
            },
          }}
        >
          {meetingLoading ? (
            <Grid spacing={2} container>
              {/* Card 1 */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  <Grid container spacing={4} p={3}>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        height="100vh"
                      >
                        <CircularProgress />
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          ) : (
            <Grid spacing={2} container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ padding: 1 }}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        // startIcon={<VisibilityIcon />}
                        onClick={viewMeetingProfile}
                        className={classes.addButton}
                      >
                        <Link
                          to={`/meeting/profile/${selectedMeetingData?.id}`}
                          className={classes.iconLinkPropNormal}
                        >
                          View
                        </Link>
                      </Button>
                      <Box m={0.5}></Box>
                      <Button
                        variant="contained"
                        className={classes.editButton}
                        onClick={handleEditClose}
                      >
                        <CloseIcon />
                      </Button>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        // cursor: "pointer",
                      }}
                      // onClick={viewMeetingProfile}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          width: 56,
                          height: 56,
                          fontSize: 24,
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={viewMeetingProfile}
                      >
                        {selectedMeetingData?.subject ? (
                          selectedMeetingData.subject.charAt(0).toUpperCase()
                        ) : (
                          <GroupIcon />
                        )}
                      </Avatar>
                      <Link
                        to={`/meeting/profile/${selectedMeetingData?.id}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Typography
                          className={classes.mL1Heading}
                          fontWeight={700}
                          sx={{
                            cursor: "pointer",
                            mt: 0.5,
                          }}
                          onClick={viewMeetingProfile}
                        >
                          {selectedMeetingData?.subject || ""}{" "}
                          <FontAwesomeIcon
                            icon={faLink}
                            style={{
                              color: "#757575",
                              marginLeft: 4,
                            }}
                          />
                        </Typography>
                      </Link>
                    </Grid>
                  </Grid>
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={4} p={"24px"}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Subject </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              freeSolo
                              options={
                                meetingAllSubjectData?.data?.filter(Boolean) ??
                                []
                              }
                              loading={meetingAllIsLoading}
                              inputValue={formik.values.subject}
                              onInputChange={(_, value) =>
                                formik.setFieldValue("subject", value)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Subject"
                                  size="small"
                                  multiline
                                  rows={6}
                                  className={classes.textField}
                                  InputProps={{
                                    ...params.InputProps,
                                    sx: { fontSize: 14 },
                                  }}
                                  InputLabelProps={{
                                    sx: { fontSize: 14 },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Category </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={meetingCategoryOptions}
                              loading={meetingCategoryIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                meetingCategoryOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    Number(formik.values.categoryId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "categoryId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Meeting Category .."
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {meetingCategoryIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Staff </strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={staffOptions}
                              loading={staffIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                staffOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.staffId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "staffId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => {
                                const selected = staffOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.staffId)
                                );

                                return (
                                  <TextField
                                    {...params}
                                    placeholder="Select staff..."
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    variant="standard"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {staffIsLoading ? (
                                            <CircularProgress size={20} />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </>
                                      ),
                                    }}
                                  />
                                );
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Client </strong>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={customerOptions}
                              loading={allcilentIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                customerOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.clientId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "clientId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Client .."
                                  size="small"
                                  variant="standard"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {allcilentIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Policy </strong>
                              {/* <span className={classes.requiedfield}>*</span> */}
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Autocomplete
                              options={policyOptions}
                              loading={policyIsLoading}
                              getOptionLabel={(option: CustomerOption) =>
                                option.label
                              }
                              value={
                                policyOptions.find(
                                  (opt) =>
                                    opt.value === Number(formik.values.policyId)
                                ) || null
                              }
                              onChange={(
                                _,
                                newValue: CustomerOption | null
                              ) => {
                                formik.setFieldValue(
                                  "policyId",
                                  newValue?.value || ""
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Policy number .."
                                  size="small"
                                  InputLabelProps={{ shrink: true }}
                                  className="textField"
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {policyIsLoading ? (
                                          <CircularProgress size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              sx={{ width: "100%" }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Schedule Date</strong>
                              <span className={classes.requiedfield}>*</span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={formik.values.meeting_Date}
                                onChange={(meeting_Date) =>
                                  formik.setFieldValue(
                                    "meeting_Date",
                                    meeting_Date
                                  )
                                }
                                // shouldDisableDate={(day) =>
                                //   !!holydaysData?.data?.some((holiday) =>
                                //     day.isSame(dayjs(holiday), "day")
                                //   )
                                // }
                                shouldDisableDate={(day) =>
                                  !!holydaysData?.data?.some((holiday: Dayjs) =>
                                    day.isSame(holiday, "day")
                                  )
                                }
                                slotProps={{
                                  textField: {
                                    placeholder: "Schedule Date",
                                    size: "small",
                                    variant: "standard",
                                    sx: {
                                      width: "100%",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={"2px"} alignItems="center">
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography variant="subtitle1">
                              <strong>Schedule Time</strong>
                              {/* <span className={classes.requiedfield}>*</span> */}
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TimeDropdown
                              value={formik.values.meeting_time}
                              onChange={(time) =>
                                formik.setFieldValue("meeting_time", time)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="contained"
                          startIcon={
                            meetingSaveIsLoading ? (
                              <CircularProgress
                                size={18}
                                className={classes.isLoading}
                              />
                            ) : (
                              <FaEdit />
                            )
                          }
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || meetingSaveIsLoading}
                        >
                          Update
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Card>
              </Grid>
            </Grid>
          )}
        </Drawer>

        <AlertPopUp
          open={deleteAlert}
          onCloseAlert={setDeleteAlert}
          message={alertMessage}
        />
      </Grid>
    </div>
  );
};

export default Index;
